import React from 'react';
import { KeyboardAvoidingView, View, Platform } from 'react-native';
var ModalKeyboardAvoidingView = function ModalKeyboardAvoidingView(props) {
  var useKeyboardAvoidingView = props.useKeyboardAvoidingView,
    children = props.children;
  return useKeyboardAvoidingView ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React.createElement(KeyboardAvoidingView, {
    behavior: Platform.OS === 'ios' ? 'position' : 'height' // 设置键盘弹出时的行为，'padding' 适用于iOS，'height' 适用于Android
  }, children)) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default ModalKeyboardAvoidingView;